import RenderInterface from './interfaces/RenderInterface';
import ListCartHeaderInterface from './interfaces/ListCartHeaderInterface';
import TotalPrice from './RenderActions/TotalPrice';
import NumberProducts from './RenderActions/NumberProducts';
import RenderListProducts from './RenderActions/RenderListProducts';
import DisableCartHeader from './RenderActions/DisableCartHeader';
import LocalStorageService from '../../../Services/Storage/LocalStorageService';
import CartHeaderInterface from './interfaces/CartHeaderInterface';
import InfoHeaderInterface from './interfaces/InfoHeaderInterface';

/**
 * Class Cart header.
 */
export default class CartHeader {
  static selector = '.c-cartHeader__listProducts';

  static element: HTMLElement = document.querySelector(CartHeader.selector);

  static templateElement: HTMLElement = document.querySelector('.list-product');

  static data: any;

  static keyName = 'cartData';

  constructor() {
    // Init app
    const { listProducts, infoHeader } = CartHeader.getDataCartHeader();

    if (document.querySelector('.c-cartHeader')) {
      CartHeader.data = listProducts;
      CartHeader.render({ type: 'createList', data: CartHeader.data });

      // Update total price in cart
      const totalCartFormated: string = infoHeader.formattedTotalPrice;
      // const totalCart: number = <number>infoHeader.totalCart;

      TotalPrice.execute(totalCartFormated);

      // Global variable
      const Window: Window = window;
      Window.CART_HEADER = Window.CART_HEADER || CartHeader;
    }
  }

  /*
   * Get data in LocalStorage or in DOM
   * */
  static getDataCartHeader(): {
    listProducts: ListCartHeaderInterface;
    infoHeader: InfoHeaderInterface;
  } {
    let listProducts: ListCartHeaderInterface;
    let infoHeader: InfoHeaderInterface;
    const isDisableLocalStorage = CartHeader.isDisableLocalStorage();

    // Cart header in LocalStorage
    const serviceStorage = new LocalStorageService();
    const cartHeaderData: CartHeaderInterface = serviceStorage.getItem(
      CartHeader.keyName
    );

    // TODO : Désactiver localstorage dans le header le temps de fixer le bug
    /* if (cartHeaderData?.listProducts && !isDisableLocalStorage) {
      // Read data in LocalStorage cart header
      listProducts = cartHeaderData.listProducts;
      infoHeader = cartHeaderData.infoHeader;
    } else { */

    // Create new data in LocalStorage cart header
    const listProductsElement: HTMLInputElement =
      document.querySelector<HTMLInputElement>('#data-cart-items');
    const infoHeaderElement: HTMLInputElement =
      document.querySelector<HTMLInputElement>('#data-cart-info');

    listProducts =
      listProductsElement && listProductsElement.value
        ? JSON.parse(listProductsElement.value)
        : {};

    infoHeader =
      infoHeaderElement && infoHeaderElement.value
        ? JSON.parse(infoHeaderElement.value)
        : {};

    // Push to local storage
    serviceStorage.setItem(CartHeader.keyName, {
      listProducts: { ...listProducts },
      infoHeader,
    });

    // TODO : Désactiver localstorage dans le header le tamps de fixer le bug
    // }

    return {
      listProducts,
      infoHeader,
    };
  }

  /*
   * Disable LocalStorage in specific page
   * */
  static isDisableLocalStorage(): boolean {
    const body: HTMLElement = document.querySelector('body');
    const isAccountPage = body.classList.contains('mes-commandes');
    const isNewCartPage = !!document.querySelector('.l-cart');
    const isNewCheckoutPage = !!document.querySelector('.l-checkout');
    const isNewConnexionPage = body.classList.contains('l-authentication');
    const isNewCheckoutSuccessPage =
      body.classList.contains('l-checkout-success');

    return (
      isAccountPage ||
      isNewCartPage ||
      isNewCheckoutPage ||
      isNewConnexionPage ||
      isNewCheckoutSuccessPage
    );
  }

  /*
   * Update list products object
   * */
  static updateListProducts(
    listProducts: ListCartHeaderInterface,
    totalCartFormated: string
  ): void {
    CartHeader.data = listProducts;

    CartHeader.render({ type: 'createList', data: CartHeader.data });

    CartHeader.updateCartData(totalCartFormated);
  }

  /*
   * Delete product object
   * */
  private static deleteProduct(
    listProducts: ListCartHeaderInterface,
    formattedTotalPrice: string
  ): void {
    CartHeader.data = listProducts;

    CartHeader.render({ type: 'createList', data: CartHeader.data });

    CartHeader.updateCartData(formattedTotalPrice);
  }

  /*
   * Update cart data
   * */
  private static updateCartData(formattedTotalPrice: string): void {
    // Update total price in cart
    TotalPrice.execute(formattedTotalPrice);

    // Cart header in LocalStorage
    const serviceStorage = new LocalStorageService();
    const listProducts: ListCartHeaderInterface = CartHeader.data;

    // Push to local storage
    serviceStorage.setItem(CartHeader.keyName, {
      listProducts,
      infoHeader: { formattedTotalPrice },
    });
  }

  /*
   * Render html
   * */
  private static render(render: RenderInterface) {
    // Update total products in cart
    const numberProducts: number = NumberProducts.execute(CartHeader.data);

    // Disable or enable Cart
    DisableCartHeader.execute(numberProducts);

    // Render list products in cart
    RenderListProducts.execute(
      render,
      CartHeader.element,
      CartHeader.templateElement,
      CartHeader.updateListProducts,
      CartHeader.data
    );
  }
}

declare global {
  interface Window {
    CART_HEADER: CartHeader;
    dataLayer: any;
  }
}
